/* generated using openapi-typescript-codegen -- do not edit */

/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
import type { SchemaSourceWorkflow } from "./SchemaSourceWorkflow"

export type WorkflowDeploymentConstantFeature = {
  name: string
  /**
   * * `TEXT` - Text
   * * `NUMBER` - Number
   * * `BOOLEAN` - Boolean
   * * `DATE` - Date
   * * `LIST` - List
   * * `UNDEFINED` - Undefined
   * * `DICT` - dict
   */
  type: WorkflowDeploymentConstantFeature.type
  feature_nesting_separator?: string
  source_workflows: Array<SchemaSourceWorkflow>
}
export namespace WorkflowDeploymentConstantFeature {
  /**
   * * `TEXT` - Text
   * * `NUMBER` - Number
   * * `BOOLEAN` - Boolean
   * * `DATE` - Date
   * * `LIST` - List
   * * `UNDEFINED` - Undefined
   * * `DICT` - dict
   */
  export enum type {
    TEXT = "TEXT",
    NUMBER = "NUMBER",
    BOOLEAN = "BOOLEAN",
    DATE = "DATE",
    LIST = "LIST",
    // TODO: uncomment when dict is supported
    // DICT = "DICT",
  }
}
